import { useQuery } from 'react-query';
import type { QueryOptions } from 'react-query';
import StateService from '../../services/stateService';
import useAbortController from '../../hooks/useAbortController';

const placeholderData = [];
const useStatesQuery = ({ options = {} }: { options: QueryOptions } = {}) => {
  const abortControllerOptions = useAbortController();
  const queryKey = ['states'];

  return useQuery(
    queryKey,
    () => {
      const stateService = new StateService();
      return stateService.getAll(abortControllerOptions);
    },
    { ...options, placeholderData },
  );
};

export default useStatesQuery;
